import React, { useState } from "react";

export default function ConnectionHealthBanner({ healthSummary }) {
    const [dismissed, setDismissed] = useState(false);

    const handleDismiss = () => {
        setDismissed(true);
    };

    if (dismissed) {
        return null;
    }

    const { totalConnections, needsAttention } = healthSummary || {};
    const allHealthy = needsAttention === 0 && totalConnections > 0;

    if (allHealthy) {
        return (
            <div className="flex items-center gap-2 px-3 py-1.5 bg-success-50 border border-success-100 rounded-md mb-6">
                <svg className="w-3.5 h-3.5 text-success-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-xs text-gray-600 flex-1">
                    {totalConnections === 1 ? 'Connection healthy' : `All ${totalConnections} connections healthy`}
                </span>
                <button
                    onClick={handleDismiss}
                    className="p-0.5 text-gray-400 hover:text-gray-700 transition-colors"
                    aria-label="Dismiss"
                >
                    <svg className="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        );
    }

    // Show warning if there are issues
    if (needsAttention > 0) {
        return (
            <div className="flex items-center gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg mb-6">
                <div className="text-amber-600">
                    <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </div>
                <div className="flex-1">
                    <span className="text-amber-600 font-medium">
                        {needsAttention} connection{needsAttention !== 1 ? 's' : ''} need{needsAttention === 1 ? 's' : ''} attention
                    </span>
                    <span className="text-gray-500 text-sm ml-2">
                        Go to Accounts to reconnect
                    </span>
                </div>
                <button
                    onClick={handleDismiss}
                    className="p-1 text-gray-400 hover:text-gray-900 transition-colors"
                    aria-label="Dismiss"
                >
                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        );
    }

    return null;
}
